import React from 'react'

const GraphLegendChip = ({ color }) => (
	<rect id="Rectangle_1934" data-name="Rectangle 1934" width="16" height="8" x="4" y="8" fill={color} rx="1" ry="1" />
)

export default GraphLegendChip